import { render, staticRenderFns } from "./CarouselMultiPic.vue?vue&type=template&id=0dcdde72&"
import script from "./CarouselMultiPic.vue?vue&type=script&lang=js&"
export * from "./CarouselMultiPic.vue?vue&type=script&lang=js&"
import style0 from "./CarouselMultiPic.vue?vue&type=style&index=0&id=0dcdde72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports